import { useAuth } from "@/shared/session";
import { USER_ROLES } from "../consts";

export interface UserAccessProps {
  children?: React.ReactNode;
  /**
   * - The permission required to access the children.
   * - If the permission is an array, the user will be able to access the children if they have at least one of the permissions.
   * - If the permission is not provided, the children will be accessible.
   */
  roles?: keyof typeof USER_ROLES | (keyof typeof USER_ROLES)[];
  /**
   * Component to render when the user does not have the required permission.
   */
  fallback?: React.ReactNode;
}

export const UserAccess = ({ children, roles, fallback }: UserAccessProps) => {
  const { user } = useAuth();

  const rolesList = Array.isArray(roles) ? roles : roles ? [roles] : [];

  if (!user?.stocksConfig?.roleId) return fallback;

  const hasPermission = rolesList?.some(
    (p) => p && user.stocksConfig.roleId === USER_ROLES[p],
  );

  if (!rolesList.length || hasPermission) {
    return children;
  }

  return fallback;
};
